import React, { useState } from "react";
import gallery1 from "../../assets/images/gallery1.jpg";
import gallery2 from "../../assets/images/gallery2.jpg";
import gallery3 from "../../assets/images/gallery3.jpg";
import gallery4 from "../../assets/images/gallery4.jpg";
import gallery5 from "../../assets/images/gallery5.jpg";
import gallery6 from "../../assets/images/gallery6.jpg";
import gallery7 from "../../assets/images/gallery7.jpg";
import gallery8 from "../../assets/images/gallery8.jpg";
import gallery9 from "../../assets/images/gallery9.jpg";
import { IoArrowBackOutline, IoArrowForwardOutline } from "react-icons/io5";

const IoArrowBackOutlineIcon = IoArrowBackOutline as React.ElementType;
const IoArrowForwardOutlineIcon = IoArrowForwardOutline as React.ElementType;
// Example filter categories
const categories = [
  "All",
  "Delhi",
  "Mumbai",
  "Kochi",
  "Events",
  "Recruitment",
  "Delegations",
];

// Example image data
interface GalleryImage {
  src: string;
  alt: string;
  category: string; // Use for filtering
}

const galleryImages: GalleryImage[] = [
  // Fill in your own image paths and categories
  { src: gallery1, alt: "Event 1", category: "Delhi" },
  { src: gallery2, alt: "Event 1", category: "Delhi" },
  { src: gallery3, alt: "Event 1", category: "Delegations" },
  { src: gallery4, alt: "Event 1", category: "Delegations" },
  { src: gallery5, alt: "Event 1", category: "Events" },
  { src: gallery6, alt: "Event 1", category: "Kochi" },
  { src: gallery7, alt: "Event 1", category: "Recruitment" },
  { src: gallery8, alt: "Event 1", category: "Delhi" },
  { src: gallery9, alt: "Event 2", category: "Mumbai" },
  { src: gallery9, alt: "Event 2", category: "Events" },
  { src: gallery9, alt: "Event 2", category: "Events" },
  { src: gallery9, alt: "Event 2", category: "Events" },
  { src: gallery9, alt: "Event 2", category: "Events" },

  // ...add all your images here
];

const imagesPerPage = 12;

const GalleryComponent: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const [page, setPage] = useState(1);

  // Filter and paginate images
  const filteredImages =
    activeCategory === "All"
      ? galleryImages
      : galleryImages.filter((img) => img.category === activeCategory);

  const pageCount = Math.ceil(filteredImages.length / imagesPerPage);
  const pagedImages = filteredImages.slice(
    (page - 1) * imagesPerPage,
    page * imagesPerPage
  );

  // Handlers
  function handleTab(cat: string) {
    setActiveCategory(cat);
    setPage(1);
  }
  function goToPage(p: number) {
    setPage(p);
  }

  return (
    <div className="bg-white max-w-7xl mx-auto px-4 md:px-8 xl:pt-20 lg:pt-16 py-10">
      {/* TAB FILTERS */}
      <div className="flex justify-center">
        <div className="md:bg-[#EAF0F6] w-fit p-1 md:rounded-full flex md:flex-row flex-col justify-center gap-2 mb-6">
          {categories.map((cat, idx) => (
            <button
              key={idx}
              onClick={() => handleTab(cat)}
              className={`lg:px-6 px-4 py-2 rounded-full text-[16px]  font-extrabold ${
                activeCategory === cat
                  ? "bg-[#c40808] text-white"
                  : " text-[#0E313A]"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>
      {/* GALLERY GRID */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-12">
        {pagedImages.map((img, idx) => (
          <div key={idx} className="relative">
            <img
              src={img.src}
              alt={img.alt}
              className="w-full h-[250px] object-cover border border-[#eee]"
            />
          </div>
        ))}
      </div>
      {/* PAGINATION */}
      <div className="flex border-[#EAECF0] border-t-[2px] font-inter font-semibold justify-between items-center px-1 py-8">
        <button
          className={`md:flex hidden gap-2 items-center px-4 py-2 border-[#D0D5DD] border-[2px] rounded-lg ${
            page === 1 ? "text-[#344054]" : "text-[#333]"
          }`}
          onClick={() => goToPage(Math.max(page - 1, 1))}
          disabled={page === 1}
        >
          <IoArrowBackOutlineIcon className="text-[22px]" /> Previous
        </button>
        <button
          className={`flex md:hidden gap-2 items-center px-4 py-2 border-[#D0D5DD] border-[2px] rounded-lg ${
            page === 1 ? "text-[#344054]" : "text-[#333]"
          }`}
          onClick={() => goToPage(Math.max(page - 1, 1))}
          disabled={page === 1}
        >
          <IoArrowBackOutlineIcon className="text-[22px]" /> 
        </button>
        <div className="flex items-center gap-1">
          {[...Array(pageCount)].map((_, idx) => (
            <button
              key={idx}
              className={`w-10 h-10 rounded-lg ${
                page === idx + 1
                  ? "bg-[#F9F5FF] text-[#7F56D9] font-bold"
                  : "bg-white text-[#667085]"
              }`}
              onClick={() => goToPage(idx + 1)}
            >
              {idx + 1}
            </button>
          ))}
        </div>
        <button
          className={`md:flex hidden gap-2 items-center px-4 py-2 border-[#D0D5DD] border-[2px] rounded-lg ${
            page === pageCount ? "text-[#344054]" : "text-[#333]"
          }`}
          // Next (correct ↑)
          onClick={() => goToPage(Math.min(page + 1, pageCount))}
          disabled={page === pageCount}
        >
          Next <IoArrowForwardOutlineIcon className="text-[22px]" />
        </button>
        <button
          className={`flex md:hidden gap-2 items-center px-4 py-2 border-[#D0D5DD] border-[2px] rounded-lg ${
            page === pageCount ? "text-[#344054]" : "text-[#333]"
          }`}
          // Next (correct ↑)
          onClick={() => goToPage(Math.min(page + 1, pageCount))}
          disabled={page === pageCount}
        >
          <IoArrowForwardOutlineIcon className="text-[22px]" />
        </button>
      </div>
    </div>
  );
};

export default GalleryComponent;
